import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";

const HEADER_OFFSET = 80;

export function scrollToHash(hash: string) {
  const id = hash.replace("#", "");
  if (!id) return;
  let tries = 0;
  const tick = () => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({ top, behavior: "smooth" });
      return;
    }
    if (tries++ < 40) setTimeout(tick, 100);
  };
  tick();
}

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      scrollToHash(hash);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname, hash]);

  return null;
}
